<template>
  <div class="page-container">
    <el-card class="page-content">
      <div class="page-actions">
        <el-select v-model="coinType" placeholder="请选择coinType" clearable size="mini">
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-select v-model="txStatus" placeholder="请选择txStatus" clearable size="mini">
          <el-option v-for="item in txStatusOption" :key="item.value" :label="item.lable"
            :value="item.value"></el-option>
        </el-select>
        <el-select v-model="txType" placeholder="请选择充值类型" clearable size="mini">
          <el-option v-for="item in txTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-input placeholder="请输入userId" v-model="userId" clearable size="mini">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入转入钱包地址" v-model="walletAddres" clearable size="mini">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button size="mini" type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="exportData" size="mini">导出Excel</el-button>
        <!-- <span>待查询的Hash值为：{{hash}}</span> -->
      </div>
      <AuditList @refresh="handleSearch($event)" />
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import AuditList from "./components/list";
import api from "./api";
import qs from "qs";
export default {
  name: "loglim",
  data() {
    return {
      coinType: "",
      userId: "",
      txStatus: "",
      txType: "",
      txTypeList: [
        { value: 1, label: '充值' },
        { value: -2, label: '内部转入' }
      ],
      walletAddres: "",
      txStatusOption: [
        { lable: "已经确认", value: 0 },
        { lable: "已提交", value: 1 },
        { lable: "取消", value: 2 },
        { lable: "失败", value: -1 },
        { lable: "确认中", value: 3 },
        { lable: "已审核", value: 4 },
        { lable: "区块链网络已经发送， 等待确认中", value: 5 },
        { lable: "系统错误", value: 6 },
        { lable: "管理员退回", value: 7 },
        { lable: "余额变更异常", value: 9 },
      ],
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("depositeRecord", ["pagination", "coinList"]),
  },
  methods: {
    ...mapActions("depositeRecord", ["gethashList", "getCoinList"]),
    handleSearch() {
      // let coin = this.$route.query.coin;
      // let toAddress = this.$route.query.toAddress;
      // if (coin&&toAddress) {
      this.gethashList({
        coinType: this.coinType,
        userId: this.userId,
        txStatus: this.txStatus,
        txType: this.txType,
        walletAddres: this.walletAddres,
        type: 1,
        ...this.pagination,
      });
      // } else {
      //   this.$message.error("币种和地址不能为空");
      //   return;
      // }
    },
    exportData() {
      const data = {
        coinType: this.coinType,
        userId: this.userId,
        txStatus: this.txStatus,
        txType: this.txType,
        walletAddres: this.walletAddres,
        type: 1,
        txType: this.txType,
        ...this.pagination,
      };
      const params = qs.stringify(data);
      api.getExcelData(params).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址

        link.download = "充值记录报表";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
  },
  mounted() {
    this.handleSearch();
    this.getCoinList();
  },
};
</script>

<style lang="less" scoped></style>
